/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersSubscriptionsRegisterPutRequest model module.
 * @module model/CustomersSubscriptionsRegisterPutRequest
 * @version 1.0.0
 */
class CustomersSubscriptionsRegisterPutRequest {
    /**
     * Constructs a new <code>CustomersSubscriptionsRegisterPutRequest</code>.
     * @alias module:model/CustomersSubscriptionsRegisterPutRequest
     * @param email {String} 
     * @param registered {Boolean} 
     */
    constructor(email, registered) { 
        
        CustomersSubscriptionsRegisterPutRequest.initialize(this, email, registered);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, email, registered) { 
        obj['email'] = email;
        obj['registered'] = registered;
    }

    /**
     * Constructs a <code>CustomersSubscriptionsRegisterPutRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersSubscriptionsRegisterPutRequest} obj Optional instance to populate.
     * @return {module:model/CustomersSubscriptionsRegisterPutRequest} The populated <code>CustomersSubscriptionsRegisterPutRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersSubscriptionsRegisterPutRequest();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('registered')) {
                obj['registered'] = ApiClient.convertToType(data['registered'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersSubscriptionsRegisterPutRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersSubscriptionsRegisterPutRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CustomersSubscriptionsRegisterPutRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}

CustomersSubscriptionsRegisterPutRequest.RequiredProperties = ["email", "registered"];

/**
 * @member {String} email
 */
CustomersSubscriptionsRegisterPutRequest.prototype['email'] = undefined;

/**
 * @member {Boolean} registered
 */
CustomersSubscriptionsRegisterPutRequest.prototype['registered'] = undefined;






export default CustomersSubscriptionsRegisterPutRequest;

